@if (details.get('Sign'); as signs) {
  <div class="col">
    <div class="sign-container">
      @for (sign of signs?.items; track sign) {
        <app-sprite-image [iconName]="sign.description" [type]="'large'"></app-sprite-image>
      }
    </div>
  </div>
}

@if (details.get('Supplementary Signs'); as signs) {
  <div class="col">
    <div class="d-flex row flex-wrap gap-2 mt-2">
      @for (sign of details.get('Supplementary Signs')?.items; track sign) {
        <div class="position-relative d-inline-block supplementary-sign-container">
          <app-sprite-image [iconName]="sign.description" [type]="'large'"></app-sprite-image>
          <!-- Keep UNKNOWN_TYPE text overlay -->
          @if (sign.description === 'UNKNOWN_TYPE') {
            <span
              class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center text-black no-wrap unknown-type-overlay"
              [ngStyle]="{
                'line-height': '1',
                'font-size': 'clamp(8px, 2vw, 16px)',
                'white-space': 'pre-line',
              }"
            >
              {{ sign.value }}
            </span>
          }
        </div>
      }
    </div>
  </div>
}
